<template>
  <Page title="Podgląd zgłoszenia">
    <component :is="loadedForm" :disabled="true" mode="view"></component>
  </Page>
</template>

<script>
import Certification from "./UserCertification";

export default {
  name: "CertificationViewView",
  extends: Certification
};
</script>

<style class="scss"></style>
